import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 2fr 1fr',
    alignItems: 'center',
    paddingLeft: 12,
    color: 'grey',
    borderRadius: 20,
    marginBottom: 4,
    backgroundColor: theme.palette.background.default,
    textAlign: 'left',
    height: 52,
    transition: 'background-color 0.3s ease-in-out',
    overflowY: 'auto'
  }
}))
export default useStyles
